module.exports = __webpack_public_path__ + "img/0Q3A3494_L_Wood.8b5cb516.jpg";